module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_moere_og_romsdal_pos.88f9efdb.png";